import React from 'react';
import { each } from 'lodash';
// import PropTypes from 'prop-types';
import Button from 'partial/components/Button';
import FormSelect from 'partial/form/FormSelect';

const TEMPLATES = {
  passport: {
    value: 'passport',
    label: 'Passport',
    template_url: 'https://ucarecdn.com/5607efe0-2029-4982-a8d7-bc136a66c04a/',
    width: 500,
    height: 342,
    bounds: {
      photo: [22, 5.5, 72, 32],
      first_name: [29.5, 33, 35.5, 60],
      middle_name: [38, 33, 44, 60],
      last_name: [22, 33, 28, 60],
      // birth_date: [],
      // nationality: [],
      // gender: [],
      // birth_place: [],
      // issue_date: [],
      // valid_date: [],
      // issue_by: [],
      // passport_no: [],
      mrz: [80, 4, 97, 97],
    },
    meta: [],
  },
};

// eslint-disable-next-line
const RenderBounds = ({ data, width, height }) => {
  const list = React.useMemo(() => {
    const temp = [];
    each(data, (v, k) => {
      const top = (v[0] / 100) * height;
      const left = (v[1] / 100) * width;
      const h = (v[2] / 100) * height - top;
      const w = (v[3] / 100) * width - left;
      temp.push({
        id: k,
        style: {
          top,
          left,
          height: h,
          width: w,
        },
      });
    });
    return temp;
  }, [data, width, height]);
  return list.map((item) => {
    return (
      <div
        className="absolute z-20 border border-red-500 flex text-white bg-black/30"
        style={item.style}
      >
        <div className="m-auto">{item.id}</div>
      </div>
    );
  });
};

// eslint-disable-next-line
function PhotoSnippet({ data, label, src, width, height }) {
  const newUrl = React.useMemo(() => {
    const t = Math.round((data[0] / 100) * height);
    const l = Math.round((data[1] / 100) * width);
    const h = Math.round((data[2] / 100) * height - t);
    const w = Math.round((data[3] / 100) * width - l);

    return `${src}-/resize/${width}x${height}/-/crop/${w}x${h}/${l},${t}/`;
  }, [data, src, width, height]);
  return (
    <div className="flex justify-between">
      <div>{label}</div>
      <div className="border p-1 rounded-lg inline-block">
        <img className="h-20 w-72 object-contain" src={newUrl} alt={label} />
      </div>
    </div>
  );
}

function IdTemplate() {
  const [form, setForm] = React.useState({ template: null });
  const selected = React.useMemo(() => TEMPLATES[form.template], [
    form.template,
  ]);
  return (
    <div className="container mx-auto p-3">
      <div className="grid grid-cols-2 gap-5">
        <div className="bg-white rounded shadow border p-5 space-y-3">
          <div>
            <FormSelect
              name="template"
              onChange={setForm}
              value={form.template || ''}
              options={Object.values(TEMPLATES)}
              placeholder="- Select Template -"
              required
            />
          </div>
          <div className="h-0 -mx-5 border-t" />
          <div>
            {selected?.template_url ? (
              <div
                className="relative mx-auto"
                style={{ width: selected?.width, height: selected?.height }}
              >
                <img
                  className="absolute z-0 h-full w-full object-fit object-center"
                  src={selected?.template_url}
                  alt=""
                />
                <RenderBounds
                  data={selected?.bounds || {}}
                  width={selected?.width}
                  height={selected?.height}
                />
              </div>
            ) : (
              <div className="text-center">No ID</div>
            )}
          </div>
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <div>ID Photo</div>
              <div>Selfie Photo</div>
            </div>
            <div className="divide-y">
              {Object.keys(selected?.bounds || {}).map((key) => (
                <div key={key} className="py-3">
                  <PhotoSnippet
                    data={selected?.bounds[key]}
                    label={key}
                    src={selected?.template_url}
                    width={selected?.width}
                    height={selected?.height}
                  />
                </div>
              ))}
            </div>
          </div>
          <div>
            <Button primary>Match</Button>
          </div>
        </div>
        <div className="bg-white rounded shadow border p-5">
          <div>Result</div>
          <div>
            <Button>Clear</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

IdTemplate.propTypes = {};

export default IdTemplate;
